import { useTranslation } from 'react-i18next'

import type { StatusConfig } from '../../components/StatusBadge'

export type ProductStatus = 'DRAFT' | 'PUBLISHED' | 'ARCHIVED' | 'SOLD_OUT'
type SalesChannel = 'BROADCAST' | 'MARKETPLACE'

export type ProductStatusConfigMap = Record<ProductStatus, StatusConfig>
export type SalesChannelConfigMap = Record<SalesChannel, StatusConfig>

export function useProductStatusConfig(): ProductStatusConfigMap {
  const { t } = useTranslation()

  return {
    DRAFT: { color: 'default', label: t('common.status.draft') },
    PUBLISHED: { color: 'green', label: t('common.status.published') },
    ARCHIVED: { color: 'orange', label: t('common.status.archived') },
    SOLD_OUT: { color: 'red', label: t('common.status.soldOut') },
  }
}

export function useSalesChannelConfig(): SalesChannelConfigMap {
  const { t } = useTranslation()

  return {
    BROADCAST: { color: 'purple', label: t('common.status.broadcast') },
    MARKETPLACE: { color: 'cyan', label: t('common.status.marketplace') },
  }
}
